import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';

/**
 * Hook to handle payment success/failure feedback from query params
 * This hook only handles side effects (toast notifications and query param cleanup)
 */
export function usePaymentStatusFeedback(): void {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const paymentStatus = searchParams.get('payment');
    if (paymentStatus === 'success') {
      toast.success('Payment successful! Your order has been confirmed.');
      // Clear the query param
      setSearchParams((prev) => {
        prev.delete('payment');
        return prev;
      });
    } else if (paymentStatus === 'failed') {
      toast.error('Payment failed. Please try again.');
      // Clear the query param
      setSearchParams((prev) => {
        prev.delete('payment');
        return prev;
      });
    }
  }, [searchParams, setSearchParams]);
}

